import React, { useState } from "react";
import { Tabs } from "antd";
import SupportLayout from "../support/SupportLayout";
import NotificationRulesManager from "./components/NotificationRulesManager";
import NotificationTemplatesManager from "./components/NotificationTemplatesManager";
import NotificationPreferencesManager from "./components/NotificationPreferencesManager";
import NotificationTestManager from "./components/NotificationTestManager";

const AdminNotifications = () => {
  const [activeTab, setActiveTab] = useState("rules");

  return (
    <SupportLayout userRole="ADMIN">
      <div className="pb-40">
        <div className="main_container_title_div mb-5 mt-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">
            Notification Management
          </h1>
          <p className="text-gray-600 text-xl sm:text-base">
            Configure notification rules, templates, and user preferences
          </p>
        </div>

        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          type="card"
          className="support-tabs"
        >
          <Tabs.TabPane tab="Rules" key="rules">
            <div className="mt-6">
              <NotificationRulesManager />
            </div>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Templates" key="templates">
            <div className="mt-6">
              <NotificationTemplatesManager />
            </div>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Preferences" key="preferences">
            <div className="mt-6">
              <NotificationPreferencesManager />
            </div>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Test" key="test">
            <div className="mt-6">
              <NotificationTestManager />
            </div>
          </Tabs.TabPane>
        </Tabs>
      </div>
    </SupportLayout>
  );
};

export default AdminNotifications;
